import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import DataWarehouseBlockData from '../../../Models/Content/DataWarehouseBlockData';
import { ComponentProps } from '@episerver/spa-core/EpiComponent';
import { reportDWH } from './dataWarehouseBlockSlice'

const DataWarehouseBlock = ({ data, context }: ComponentProps<DataWarehouseBlockData>) => {
  const dispatch = useDispatch();

  const reportObj = {
    channel: data.channel.value,
    area: data.area.value,
    subArea: data.subArea.value,
    actionType: data.actionType.value,
    status: data.statusDWH.value,
    messageText: data.messageText.value
  }

  useEffect(() => {
    // Check if the page is refreshed
    if (performance.navigation.type === 1) {//Page was refreshed
    } else { //Page was not refreshed
      dispatch(reportDWH(reportObj));
    }
  }, []);

  return (<></>);
};

export default DataWarehouseBlock;
